import React from 'react';

export type Page = 'step1' | 'step2' | 'confirm';

export const StepArea = ({ currentPage }: { currentPage: Page }) => {
  return (
    <div className="flex flex-row items-center justify-center mb-6">
      <div
        className="grid"
        style={{ gridTemplateColumns: 'auto auto auto auto auto' }}>
        {currentPage === 'step1' ? (
          <>
            <div
              className="mb-0.5 text-1.5xs text-teal-500 font-bold"
              style={{ gridArea: '1/1' }}>
              STEP
            </div>
          </>
        ) : (
          <></>
        )}
        <div
          className={`flex items-center justify-center text-sm text-white ${
            currentPage === 'step1' ? 'bg-teal-500' : 'bg-gray-400'
          } rounded-full`}
          style={{ width: '24px', height: '24px', gridArea: '2/1' }}>
          1
        </div>
        <div className="relative w-10" style={{ gridArea: '2/2' }}>
          <div
            className={`w-full border-t border-dashed ${
              currentPage === 'step2' ? 'border-teal-500' : 'border-gray-400'
            } absolute`}
            style={{ top: '50%' }}
          />
        </div>
        {currentPage === 'step2' ? (
          <>
            <div
              className="mb-0.5 text-1.5xs text-teal-500 font-bold"
              style={{ gridArea: '1/3' }}>
              STEP
            </div>
          </>
        ) : (
          <></>
        )}
        <div
          className={`flex items-center justify-center text-sm text-white ${
            currentPage === 'step2' ? 'bg-teal-500' : 'bg-gray-400'
          } rounded-full`}
          style={{ width: '24px', height: '24px', gridArea: '2/3' }}>
          2
        </div>
        <div className="relative w-10" style={{ gridArea: '2/4' }}>
          <div
            className={`w-full border-t border-dashed ${
              currentPage === 'confirm' ? 'border-teal-500' : 'border-gray-400'
            } absolute`}
            style={{ top: '50%' }}
          />
        </div>
        {currentPage === 'confirm' ? (
          <>
            <div
              className="ml-0.5 mb-0.5 text-1.5xs text-teal-500 font-bold"
              style={{ gridArea: '1/5' }}>
              STEP
            </div>
          </>
        ) : (
          <></>
        )}
        <div
          className={`flex items-center ml-0.5 text-sm ${
            currentPage === 'confirm' ? 'text-teal-500' : 'text-gray-400'
          } font-bold`}
          style={{ gridArea: '2/5' }}>
          <div>確認</div>
        </div>
      </div>
    </div>
  );
};
